import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';
import {ThemeService} from "./services/ThemeService";
import {AppUserFacade} from "./store/app-user/app-user.facade";

declare const brandie: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Echo Design';
  environment = environment.production

  constructor(private themeService: ThemeService, private appUsers: AppUserFacade) {
    const {primaryColor, onPrimaryColor, secondaryColor} = appUsers.getBrandTheme();
    this.themeService.applyTheme(primaryColor, onPrimaryColor, secondaryColor);
  }
}
